import { jsxs as e, jsx as C } from "react/jsx-runtime";
const i = (r) => /* @__PURE__ */ e(
  "svg",
  {
    width: "42",
    height: "42",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    children: [
      /* @__PURE__ */ C("rect", { width: "50", height: "50", rx: "6", fill: "rgb(var(--brand-primary))" }),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.8666 33.3232L23.0246 37.4275C23.3113 37.8 23.261 38.3274 22.9128 38.6432L21.8268 39.6289C21.6328 39.8048 21.3994 39.8831 21.1386 39.8595C20.8778 39.836 20.663 39.7165 20.5029 39.5093L17.0017 34.9772L19.8666 33.3232ZM37.19 22.79H40.4062C40.9207 22.79 41.337 22.3699 41.3359 21.8561C41.3348 21.3416 40.9153 20.9259 40.4016 20.9259H37.1853C36.6709 20.9259 36.2546 21.3461 36.2556 21.8598C36.2566 22.3744 36.6761 22.79 37.19 22.79ZM33.3723 14.3218L34.9805 11.5364C35.2374 11.0914 35.0872 10.5203 34.6422 10.2621C34.1978 10.0044 33.6257 10.1548 33.3685 10.6003L31.7604 13.3856C31.5035 13.8306 31.6537 14.4017 32.0987 14.6599C32.5431 14.9177 33.1151 14.7673 33.3723 14.3218ZM37.0935 17.6581L39.734 16.1337C40.1822 15.8749 40.3358 15.3019 40.077 14.8535C39.8182 14.4053 39.2452 14.2518 38.7969 14.5106L36.1564 16.0351C35.7082 16.2939 35.5546 16.8669 35.8134 17.3152C36.0722 17.7634 36.6452 17.9169 37.0935 17.6581ZM32.9406 21.8529L36.055 27.2473C36.6398 28.2601 36.2895 29.5672 35.2767 30.1519C34.3316 30.6976 33.1303 30.429 32.4988 29.5676H32.4987C29.0513 29.0432 24.5606 29.6066 20.0953 31.3473L15.8024 23.9118C19.544 20.9183 22.2856 17.33 23.5552 14.0822L23.5553 14.0821C23.1093 13.1001 23.4757 11.9114 24.4281 11.3615C25.441 10.7767 26.748 11.127 27.3327 12.1398L30.4472 17.5342C30.5359 17.4657 30.6301 17.4023 30.7298 17.3447C31.9332 16.6499 33.4721 17.0622 34.1669 18.2657C34.8618 19.4692 34.4494 21.0081 33.246 21.7029C33.1463 21.7605 33.0442 21.8104 32.9406 21.8529ZM19.0158 32.1338L14.5175 24.3427L10.9415 26.4073C8.76855 27.6618 8.01723 30.4661 9.27171 32.639L9.27178 32.6391C10.5263 34.8119 13.3305 35.5633 15.5035 34.3088L19.0795 32.2442L19.0158 32.1338Z",
          fill: "rgb(var(--background-secondary))"
        }
      )
    ]
  }
);
export {
  i as ActiveCampaignIntegrationIcon
};
